import { AddressDetails } from '../types';

export const formatAddressDetails = (details: AddressDetails) => {
  const {
    address = '',
    address2 = '',
    city = '',
    country = '',
    state = '',
    zip = '',
  } = details;

  if (country === 'US') {
    return `${address}${address && address2 ? ' ' : ''}${address2}${
      (address || address2) && city ? ', ' : ''
    }${city}${(address || address2 || city) && state ? ', ' : ''}${state}${
      (address || address2 || city || state) && zip ? ' ' : ''
    }${zip}${
      (address || address2 || city || state || zip) && country ? ', ' : ''
    }${country}`;
  }

  return `${address}${address && address2 ? ' ' : ''}${address2}${
    (address || address2) && zip ? ', ' : ''
  }${zip}${(address || address2 || zip) && city ? ' ' : ''}${city}${
    (address || address2 || zip || city) && state ? ', ' : ''
  }${state}${
    (address || address2 || city || state || zip) && country ? ', ' : ''
  }${country}`;
};
